import { useConfigurationStore } from '@stores'

// Ultra Play would bypass the minimum spin time pacing, so it's unavailable when one is set.
export const useIsUltraPlayAvailable = (): boolean => {
    const hasUltraPlay = useConfigurationStore((state) => state.hasUltraPlay)
    const isUltraPlaySupported = useConfigurationStore((state) => state.isUltraPlaySupported)
    const isAutoplayDisabled = useConfigurationStore((state) => state.isAutoplayDisabled)
    // `> 0` rather than `<= 0`: the engine may omit it, and `undefined <= 0` is false.
    const hasMinimumSpinTime = useConfigurationStore((state) => state.minimumSpinTimeDuration > 0)

    return !isAutoplayDisabled && hasUltraPlay && isUltraPlaySupported && !hasMinimumSpinTime
}
